import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Input, Button } from "semantic-ui-react";
import { Formik, Form } from "formik";
import { handleResetPassword } from "../../state/auth/actions";
import {
  BoxForm,
  FormContainer,
  LoginContainer,
  Logo,
  Title,
  Subtitle,
  InputOverhead,
  Return,
} from "./styles";
import Loading from "../../components/LoadingTemplate/index";
import LogoZaivu from "../../assets/Logo-Zaivu.svg";
import ResendLinkModal from "../../components/general/AlertModals/ResendLinkModal";
import { toastAlert } from "../../components/Toastify/index";

const ForgotPasswordPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState("");

  useEffect(() => {
    if (token !== null)
      user.rank === "Gerente"
        ? history.push("/")
        : history.push({
            pathname: "/",
            search:
              "?" +
              new URLSearchParams({
                title: "",
                flowTitle: "",
                client: "",
                status: "all",
                flowType: "all",
              }).toString(),
          });
  }, [history, token]);

  const handleSubmit = (values) => {
    if (values.email === "") {
      setError(true);
    } else {
      setLoading(true);
      dispatch(handleResetPassword(values.email)).then(() => {
        setError(false);
        setLoading(false);
        setEmailSent(true);
        setSelectedEmail(values.email);
      });
    }
  };

  const handleGoLogin = () => {
    history.push("/login");
  };

  const handleResend = () => {
    dispatch(handleResetPassword(selectedEmail)).then(() => {
      toastAlert({
        msg: "Link re-enviado para o email: " + selectedEmail,
        isError: false,
      });
    });
  };

  return !loading ? (
    !emailSent ? (
      <BoxForm>
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, values, handleChange }) => (
            <Form onSubmit={handleSubmit}>
              <LoginContainer>
                <Logo src={LogoZaivu} />
                <Title>Esqueceu a senha?</Title>
                <Subtitle>
                  Acesse sua caixa de entrada, para receber o link de
                  redefinição de senha
                </Subtitle>
                <FormContainer>
                  <InputOverhead>Endereço de E-mail</InputOverhead>
                  <Input
                    icon="mail"
                    iconPosition="left"
                    style={{ marginBottom: "10px" }}
                    id="email"
                    error={error}
                    name="email"
                    placeholder="Digite seu e-mail..."
                    value={values.email}
                    onChange={handleChange}
                  />

                  {error ? (
                    <p style={{ color: "red" }}>Necessário inserir e-mail</p>
                  ) : null}
                  <Button type="submit">Enviar e-mail</Button>
                </FormContainer>
              </LoginContainer>
            </Form>
          )}
        </Formik>
        <Return onClick={handleGoLogin}> {"<"} Voltar ao login </Return>
      </BoxForm>
    ) : (
      <BoxForm>
        <ResendLinkModal
          isOpen={emailSent}
          onGoLogin={handleGoLogin}
          onConfirm={handleResend}
          chosenEmail={selectedEmail}
        />
      </BoxForm>
    )
  ) : (
    <div>
      <Loading />
    </div>
  );
};

export default ForgotPasswordPage;
